<template>
  <div>
    <div
      class="progress-bar-grid"
      :class="responsive ? 'hidden md:flex' : 'flex'"
    >
      <div class="flex flex-col">
        <span
          v-for="row in rows"
          :key="row.text"
          class="capitalize"
          :data-i18n="row?.textKey"
        >{{ row.text }}</span>
      </div>
      <div class="flex flex-col grow mx-4">
        <div
          v-for="row in rows"
          :key="row.text"
          class="w-full"
        >
          <ProgressBar
            :percentage="row.percentage"
            type="modern"
          />
        </div>
      </div>
      <div class="flex flex-col">
        <span
          v-for="row in rows"
          :key="row.text"
        >{{ row.value }}</span>
      </div>
    </div>
    <div
      class="flex-col"
      :class="responsive ? 'flex md:hidden' : 'hidden'"
    >
      <div
        v-for="row in rows"
        :key="row.text"
        class="mt-2 pt-1"
      >
        <div class="w-full flex justify-between mb-1">
          <span
            class="capitalize"
            :data-i18n="row?.textKey"
          >{{ row.text }}</span>
          <span>
            {{ row.value }}
          </span>
        </div>
        <div class="w-full">
          <ProgressBar
            :percentage="row.percentage"
            type="modern"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    /**
     * @prop {Array<{
     *   text: string
     *   percentage: number
     *   value: number
     * }>} rows
     */
    rows: {
      type: Array,
      default: () => [],
    },

    responsive: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.progress-bar-grid {
  & > div > * {
    height: 34px;
    align-items: center;
    display: flex;
  }
}
</style>
